import { useLayoutEffect } from "react";
import { Outlet } from "react-router";
import { useAppChrome } from "~/components/app/useAppChrome";

export const SupplierOnboardingLayout = () => {
  const { setMode } = useAppChrome();

  useLayoutEffect(() => {
    setMode("focused");
    return () => setMode("operational");
  }, [setMode]);

  return <Outlet />;
};
